<template>
  <div class="reportItem" @click="select" >
    <div class="reportName" >{{reportName}}</div>
  </div>
</template>

<script>
export default {
  name: 'PsReportsItem',
  props: [ 'reportName', 'path'],
  methods: {
    select () {
      this.$router.push(`/reports/detail/${this.path}`)
    }
  }
}
</script>

<style scoped>
  .reportItem { width: 295px; height: 100px; min-height: 100px; border-radius: 20px; margin: 10px 20px 10px 0; position: relative; transition: 0.3s ease;}
    
  .reportItem::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(255,255,255,1) 0%, #3E8091 100%);
    z-index: -1;
    border-radius: 20px;
  }
  .reportItem:hover {
    /* box-shadow: 1px 1px 6px 2px #aaa; */
    transform: scale(1.01);
    cursor: pointer;
  }
  .reportName { position: absolute; bottom: 5px; text-align: left; width: 100%; color: white; font-size: 28px; font-weight: bold; padding-left: 16px;}


</style>